export default [
  {
    name: 'APP_LOGIN_SUCCESS',
    callback: function (e) {
      this.snackbar = {
        show: false,
        color: '',
        text: '',
      }

      var current = this.$store.getters['account/user']
      if (current.IsAdmin) {
        this.$router.push({ path: 'admin/dashboard' })
      } else {
        var redirectUrl = localStorage.getItem('redirectUrl');
        if (redirectUrl) {
          this.$router.push(redirectUrl)
        } else {
          this.$router.push({ path: 'dashboard' })
        }
      }
    },
  },
  {
    name: 'APP_MESSAGE',
    callback: function (msg) {
      this.snackbar = {
        show: true,
        color: 'success',
        text: msg,
      }
    },
  },
  {
    name: 'APP_LOGOUT',
    callback: function (redirectUrl) {
      this.$store.dispatch('account/logout')
        .then(() => {
          this.snackbar = {
            show: false,
            color: 'success',
            text: '',
          }
          this.$router.replace({ path: '/login' })
          localStorage.setItem("redirectUrl", redirectUrl || "");
        })
        .catch(err => {
          window.getApp.$emit('APP_BAD_REQUEST', err)
        })
    },
  },
  {
    name: 'APP_PAGE_LOADED',
    callback: function (e) {
    },
  },
  {
    name: 'APP_AUTH_FAILED',
    callback: function (e) {
      this.$router.push('/login')
      this.snackbar = {
        show: true,
        color: 'error',
        text: 'Token has expired',
      }
    },
  },
  {
    name: 'APP_ERROR',
    // @error api response data
    callback: function (msg) {
      this.snackbar = {
        show: true,
        color: 'error',
        text: msg,
      }
    },
  },
  {
    name: 'APP_INFO',
    // @error api response data
    callback: function (msg) {
      this.snackbar = {
        show: true,
        color: 'info',
        text: msg,
      }
    },
  },
  {
    name: 'APP_WARNING',
    // @error api response data
    callback: function (msg) {
      this.snackbar = {
        show: true,
        color: 'warning',
        text: msg,
      }
    },
  },
  {
    name: 'APP_BAD_REQUEST',
    // @error api response data
    callback: function (msg) {
      this.snackbar = {
        show: true,
        color: 'error',
        text: msg,
      }
    },
  },
  {
    name: 'APP_ACCESS_DENIED',
    // @error api response data
    callback: function (msg) {
      this.snackbar = {
        show: true,
        color: 'error',
        text: msg,
      }
      this.$router.push('/');
    },
  },

]
